<template>
  <div>
    <h3>Event</h3>
    <vs-breadcrumb class="mt-2">
      <li>
        <router-link to="/venue-training">Event</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li v-if="venueTrainingInstance" aria-current="page" class="active">
        {{ venueTrainingInstance.title }}
      </li>
    </vs-breadcrumb>
    <vs-tabs
      :position="isSmallerScreen ? 'top' : 'left'"
      class="tabs-shadow-none mt-8"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <!-- GENERAL -->
      <vs-tab
        icon-pack="feather"
        icon="icon-info"
        :label="!isSmallerScreen ? 'General' : ''"
      >
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <venue-training-general
            :venueTrainingInstance="venueTrainingInstance"
          />
        </div>
      </vs-tab>

      <!-- ADDRESS -->
      <vs-tab
        icon-pack="feather"
        icon="icon-map-pin"
        :label="!isSmallerScreen ? 'Address' : ''"
      >
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <venue-training-address
            :venueTrainingInstance="venueTrainingInstance"
          />
        </div>
      </vs-tab>

      <!-- PARTICIPANTS -->
      <vs-tab
        icon-pack="feather"
        icon="icon-users"
        :label="!isSmallerScreen ? 'Participants' : ''"
      >
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <venue-training-participants
            :venueTrainingInstance="venueTrainingInstance"
          />
        </div>
      </vs-tab>

      <!-- DANGER ZONE -->
      <vs-tab
        icon-pack="feather"
        icon="icon-alert-triangle"
        :label="!isSmallerScreen ? 'Danger Zone' : ''"
      >
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <venue-training-danger-zone
            :venueTrainingInstance="venueTrainingInstance"
          />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import VenueTrainingGeneral from "./VenueTrainingGeneral.vue";
import VenueTrainingAddress from "./VenueTrainingAddress.vue";
import VenueTrainingParticipants from "./VenueTrainingParticipants.vue";
import VenueTrainingDangerZone from "./VenueTrainingDangerZone.vue";

export default {
  components: {
    VenueTrainingGeneral,
    VenueTrainingAddress,
    VenueTrainingParticipants,
    VenueTrainingDangerZone,
  },
  data() {
    return {
      venueTrainingId: "",
      venueTrainingInstance: null,
    };
  },
  methods: {
    getVenueTraining: function () {
      this.$vs.loading();

      const url =
        process.env.VUE_APP_API + "/VenueTrainings/" + this.venueTrainingId;

      this.$http
        .get(url)
        .then((resp) => {
          console.log("Event:", resp.data);
          this.venueTrainingInstance = resp.data;
          if (this.venueTrainingInstance.notificationMessage == null) {
            console.log("SETTING Event MESSAGE");
            this.venueTrainingInstance.notificationMessage = "";
          }
          console.log("Event after:", resp.data);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },

  created() {
    this.venueTrainingId = this.$route.params.venueTrainingId;
    this.getVenueTraining();
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
